import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';

import { UrlService } from '@core/services/url/url.service';

import { File } from '@core/objects/file';
import { Request } from '@core/objects/request';
import { Label } from '@core/objects/label';
import { Version } from '@core/objects/version';
import { Related } from '@core/objects/related';
import { VersionFeedback } from '@core/models/version-feedback';

@Component({
    selector: 'core-version-origin-version-files-list-checkbox',
    templateUrl: './origin-version-files-list-checkbox.component.html',
    styleUrls: ['./origin-version-files-list-checkbox.component.scss']
})
export class VersionOriginVersionFilesListCheckboxComponent implements OnInit, OnDestroy {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly ERROR = 2;

    @Input() request: Request;

    @Input() disabled: boolean; 
    @Input()  selected: Array<File>;
    @Output() selectedChange = new EventEmitter<Array<File>>();

    public status:number = this.LOADING;
    public artwork: Version = null;
    public group: Related;

    // imported from another comps.
    public opened: boolean = true;
    public feedbacks: Array<VersionFeedback>;

    protected subs = new Subscription();

    constructor(private httpClient: HttpClient, private urlSrv: UrlService ) { }

    ngOnInit() {
        this.loadOriginVersion();
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private loadOriginVersion() {
        this.subs.add(
            this.httpClient.get(this.urlSrv.build("/requests/" + this.request.id +"/versions"), {params: {origin: 'true', uploads: 'false'}}).subscribe({
                next: (response: Array<Version>) => {
                    if (response && response.length > 0){
                        this.artwork = response[0];
                        this.loadFeedbacks();
                        this.group = {
                            id: this.artwork.labels.map(l => l.id).join("-"),
                            total: 1,
                            labels: this.diffLabels(this.artwork.labels)
                        }
                    }
                    this.status = this.DONE;
                },
                error: (error:any) => {
                    this.status = this.ERROR;
                }
            })
        );
    }

    private diffLabels(labels: Array<Label>): Array<Label> {
        return labels.filter(vl => !this.request.labels.some(rl => vl.id == rl.id));
    }


    onChange(files: Array<File>) {
        this.selected = files;
        this.selectedChange.emit(this.selected);
    }

    openVersions() {
        this.opened = !this.opened;
    }

    loadFeedbacks() : void  {
            this.subs.add(
                this.httpClient.get(this.urlSrv.build("/p/feedback/versions/feedbacks/"+this.artwork.id)).subscribe({
                    next: (data: Array<VersionFeedback>) => {
                        this.feedbacks = data;
                    },
                    error: (err: any) => {
                        console.log(err)
                    }
                })
            );
    
        }
    public getFeedbacks(version: Version) : VersionFeedback[] | null {

            // when there are some new versions or feedbacks loading
            if(this.feedbacks == null)
                return null;
            let vFeedback = this.feedbacks.filter((f) => f.version.id == version.id);
            return vFeedback;
    }


}
